import { CrmSettingsSectionPage } from "@/pages/crm/settings/CrmSettingsSectionPage";

export function CrmSettingsModulesPage() {
  return (
    <div className="mx-auto min-h-0 w-full max-w-7xl flex-1 overflow-y-auto px-4 py-5">
      <div className="min-w-0 flex-1 rounded-xl border border-slate-200/90 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-zinc-950">
        <CrmSettingsSectionPage tab="modules" />
      </div>
    </div>
  );
}
